import React, { useState } from 'react'
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import {
    useDeleteStateCodeByIdServiceMutation,
    useGetStateCodeByIdQuery
} from "../stateCodeApi";
import IconButton from "../../../../components/common/form/IconButton";
import { FaTrash } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import ModalButton from "../../../../components/common/form/ModalButton";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import AuditableInfoButton from "../../../../components/common/form/AuditableInfoButton";
import StateCodeDetailInfo from "./StateCodeDetailInfo";
import AliasDetailInfo from "./AliasDetailInfo";
import { skipToken } from "@reduxjs/toolkit/query";
import { Routes as AppRoutes } from "../../../../routes";
import { hasPermission } from '../../../../helpers/utils/AccessControlUtils';

function StateCodesDetailPage() {

    const { codeId } = useParams();
    const navigate = useNavigate();
    const [deleteApi, { isLoading }] = useDeleteStateCodeByIdServiceMutation();

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "State Codes", url: "/state-codes" },
        { content: "Update State Code", url: "" }]
    )

    const stateCodeData = useGetStateCodeByIdQuery(codeId ?? skipToken);

    const handleDelete = async () => {
        if (codeId) {
            await deleteApi(codeId).unwrap();
        }
        navigate(AppRoutes.StateCode.path)
    };

    return (
        <div className="user-container px-5 py-5">
            <div className="flex justify-between">
                <Breadcrumb crumbs={crumbs} />

                <div className={"justify-between sm:block md:flex lg:flex"}>
                    {hasPermission(["STATCODE-D"]) &&
                        <ModalButton
                            triggerButton={
                                <IconButton
                                    icon={<FaTrash />}
                                    title={"Delete State Code"}
                                    hasBackground={true}
                                    className="mr-2"
                                />
                            }
                            modal={
                                <ConfirmationModal
                                    show={true}
                                    setShow={() => {
                                    }}
                                    title={"Delete State Code"}
                                    bodyMessage={"Are you sure you want to delete this State Code?"}
                                    onSubmit={() => handleDelete()}
                                    isLoading={isLoading}
                                />
                            }
                        />}
                    {hasPermission(["AUDIT-V"]) &&
                        <AuditableInfoButton obj={stateCodeData?.data} />}
                </div>

            </div>
            <div className="md:grid grid-cols-9 gap-4 mt-2">

                <div className="col-span-5 space-y-4">
                    <StateCodeDetailInfo  isReadOnly={hasPermission(["STATCODE-U"]) === false}/>
                </div>


                <div className="col-span-4">
                    <AliasDetailInfo />
                </div>
            </div>
        </div>
    );
}

export default StateCodesDetailPage;